export default "__VITE_ASSET__CkuLRK6R__"